export default __webpack_public_path__ + "static/media/icons-typo.23095f76.svg";